<template>
  <b-modal id="modal-request-detail" ref="modal-det" size="lg" title="Request" @show="setData" @hidden="resetModal">
    <b-form>
      <div class="row">
        <!-- grid column -->
        <div class="col-lg-12">
          <!-- .card -->
          <div class="card card-fluid">
            <!-- .card-body -->
            <div class="card-body">
              <legend><em class="fa fa-user"></em> To be filled by user</legend>
              <div class="form-row">
                <label class="col-md-3">Date of Request</label>
                <div class="col-md-6 mb-3">
                  {{detail.date_request}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Number</label>
                <div class="col-md-6 mb-3">
                  {{detail.number}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Requester Name</label>
                <div class="col-md-6 mb-3">
                  {{detail.emp_name}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Status of the request</label>
                <div class="col-md-6 mb-3">
                  {{detail.status_notes}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Project allocation</label>
                <div class="col-md-6 mb-3">
                  {{detail.project_abbreviation}} - {{detail.var_name}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Province assignment</label>
                <div class="col-md-6 mb-3">
                  {{detail.state_name}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Duty station</label>
                <div class="col-md-6 mb-3">
                  {{detail.unit_name}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Department</label>
                <div class="col-md-6 mb-3">
                  {{detail.section_name}}
                </div>
              </div>
              <legend><em class="fa fa-calendar"></em> Duration of contract</legend>
              <div class="form-row">
                <label class="col-md-3">Duration start</label>
                <div class="col-md-6 mb-3">
                  {{detail.duration_start}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Duration end</label>
                <div class="col-md-6 mb-3">
                  {{detail.duration_end}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Remarks</label>
                <div class="col-md-6 mb-3">
                  {{detail.reason}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Equipment request</label>
                <div class="col-md-6 mb-3">
                  {{detail.equipment}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Status</label>
                <div class="col-md-6 mb-3">
                  {{detail.staff_req_stat_name}}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-form>
    <template v-slot:modal-footer>
      <div class="w-100">
        <button class="btn btn-secondary float-right" @click="resetModal"> Cancel </button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import {BForm, BModal} from "bootstrap-vue";
import AxiosCall from "../../../../libs/AxiosCall";
import {urlApi} from "../../../../config/url-api";

export default {
  name: "StaffDetail",
  components:{
    BModal,
    BForm
  },
  props:{
    data:{
      type:Object
    }
  },
  data(){
    return {
      detail:{}
    }
  },
  methods:{
    setData(){
      setTimeout(()=>{
        if(this.data !== null){
          this.getDetail()
        }
      }, 100)
    },
    resetModal(){
      this.$parent.data = null
      this.detail = {}
      this.$refs['modal-det'].hide()
    },
    getDetail(){
      let payload = {
        id:this.data.id
      }
      AxiosCall.Get(payload, urlApi.staff.detail).then(res=>{
        if(res.success){
          this.detail = res.atributes
        }else{
          this.$parent.errorMessage(res.message)
        }
      }).catch(e=>{
        this.$parent.errorMessage(e.response.data.message)
      })
    }
  }
}
</script>